module.exports = "\r\n  <hc-screen-intro *ngIf=\"form.screen == 'start'\">\r\n  </hc-screen-intro>\r\n\r\n  <hc-screen-intermediate *ngIf=\"form.screen == 'feedback'\">\r\n  </hc-screen-intermediate>\r\n\r\n  <hc-screen-finish *ngIf=\"form.screen == 'result'\">\r\n  </hc-screen-finish>\r\n"


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/survey-container/survey-container.component.html
// module id = ../../../../../src/app/survey-container/survey-container.component.html
// module chunks = main